module.exports = __webpack_public_path__ + "static/media/hero_image.5573d708.svg";